import React from 'react';

import { Button } from 'js/components/common/Button';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { useTranslations } from 'js/hooks/i18n';

import styleDetails from '../../UserDetails.scss';
import style from './VerifyDetails.scss';

export const VerifyDetails = () => {
    const t = useTranslations('playtech.mobile.system.userdetails.');
    const [
        dTagUserDetailsProofIdLink = '/id-uploader',
        dTagUserDetailsProofAddressLink = '/poa-uploader'
    ] = useDynamicTags([
        DYNAMIC_TAG_NAMES.userDetailsProofIdLink,
        DYNAMIC_TAG_NAMES.userDetailsProofAddressLink
    ]);

    return (
        <div>
            <div className={styleDetails.title}>{t('varifyaccount.header')}</div>

            <div className={styleDetails.text}>{t('text.verifyaccountinfo')}</div>

            <div className={style.btnWrap}>
                <Button
                    className={style.btn}
                    href={dTagUserDetailsProofIdLink}
                >
                    {t('verifydetails.buttonone')}
                </Button>

                <Button
                    className={style.btn}
                    href={dTagUserDetailsProofAddressLink}
                >
                    {t('verifydetails.buttontwo')}
                </Button>
            </div>
        </div>
    );
};
